import React from 'react';

//
// ScanRing — soft breathing radial pulse for hero / dark sections.
// Inspired by Neko Health's hero "scan ring" but pure CSS (no canvas/WebGL).
// Honours prefers-reduced-motion via the .scan-ring CSS rule in index.css.
//
//   <ScanRing className="absolute top-1/3 right-1/4 w-[36rem] h-[36rem]" />
//
export default function ScanRing({ className = '', tone = 'teal' }) {
  const teal = 'rgba(14, 178, 171, 0.35)';
  const navy = 'rgba(2, 62, 115, 0.45)';
  const color = tone === 'navy' ? navy : teal;
  return (
    <div
      aria-hidden="true"
      className={`scan-ring pointer-events-none ${className}`}
      style={{
        background: `radial-gradient(closest-side, ${color}, transparent 70%)`,
      }}
    />
  );
}
